import { Directive,ElementRef, HostListener, Input } from '@angular/core';
import { NgModel } from '@angular/forms';

@Directive({
  selector: '[NgModel][appAlphabetsOnly]',
  providers:[NgModel]
})
export class AlphabetsOnlyDirective {

  /*constructor(private ngModel: NgModel) { }
   @HostListener('input', ['$event']) onInputChange(event) {
    const initalValue = this._el.nativeElement.value;
    this._el.nativeElement.value = initalValue.replace(/[^a-zA-Z\s]/g, '');
    if ( initalValue !== this._el.nativeElement.value) {
      event.stopPropagation();
    }
  }*/
 
  constructor(private ngModel: NgModel) { }
   @HostListener('keyup', ['$event']) onKeyUp(event:KeyboardEvent) {
    let value = this.ngModel.model;
    this.ngModel.model = value.replace(/[^a-zA-Z\s]/g, '');
    if(value !== this.ngModel.model){
      this.ngModel.update.emit(value);
    }    
  }

}
